import type { CellContext } from '@tanstack/react-table'
import { Tooltip } from '../tooltip/tooltip.tsx'

export const cellTemplate = {
  text: <TData extends {}>(props: CellContext<TData, string>) => {
    return (
      <Tooltip content={props.getValue()}>
        <span>{props.getValue()}</span>
      </Tooltip>
    )
  },
  currency:
    <TData extends {}>(
      formatter: (val?: number, fractionDigits?: number) => string
    ) =>
    (props: CellContext<TData, number>) =>
      formatter(props.getValue()),
}
